const ws = new WebSocket("wss://ws.bitstamp.net");

export default ws;
